<template>
  <div class="home-container">
    <Row>
      <p style="font-size: 20px;margin-left: 4%; margin-top: 3%;float: left">账号整体情况</p>
    </Row>
    <ul>
      <!--<li v-for="count in countInfo">-->
      <li>
        <div style="margin-top: 44px">
        <Row :gutter="16">
          <Col span="6" style="text-align: center">
          <p>
            <Icon type="chatbox-working" class="pIcon"></Icon>
            提问数量
          </p>
          <p class="showData" style="font-size: 36px;margin-top:20px">{{countInfo.questionTotal}}
            <Icon type="android-remove" class="pIconRight"></Icon>
          </p>
          </Col>
          <Col span="6">
          <p>
            <Icon type="chatboxes" class="pIcon"></Icon>
            回答总数
          </p>
          <p class="showData" style="font-size: 36px;margin-top:20px">{{countInfo.answerTotal}}
            <Icon type="android-remove" class="pIconRight"></Icon>
          </p>
          </Col>
          <Col span="6">
          <p>
            <Icon type="person" class="pIcon"></Icon>
            盲人总数
          </p>
          <p class="showData" style="font-size: 36px;margin-top:20px">{{countInfo.userTotal}}
            <Icon type="android-remove" class="pIconRight"></Icon>
          </p>
          </Col>
          <Col span="6">
          <p>
            <Icon type="android-happy" class="pIcon"></Icon>
            志愿者总数
          </p>
          <p class="showData" style="font-size: 36px;margin-top:20px">{{countInfo.volunteerTotal}}
            <Icon type="android-remove" class="pIconRight"></Icon>
          </p>
          </Col>
        </Row>
        </div>
        <div style="margin-top: 50px">
        <Row :gutter="16">
          <Col span="6" style="text-align: center">
          <p>
            <Icon type="chatbox-working" class="pIcon"></Icon>
            新增提问
          </p>
          <p class="showData" style="font-size: 36px;margin-top:20px">{{countInfo.todayQuestion}}
            <span v-if="countInfo.todayQuestion>0"><Icon type="arrow-up-a" class="pIconRightDown"></Icon></span>
            <span v-if="countInfo.todayQuestion<0"><Icon type="arrow-down-a" class="pIconRightDown"></Icon></span>
            <span v-if="countInfo.todayQuestion===0"><Icon type="android-remove" class="pIconRightDown"></Icon></span>
          </p>
          </Col>
          <Col span="6">
          <p>
            <Icon type="chatboxes" class="pIcon"></Icon>
            新增回答
          </p>
          <p class="showData" style="font-size: 36px;margin-top:20px" >{{countInfo.todayAnswer}}
            <span v-if="countInfo.todayAnswer>0"><Icon type="arrow-up-a" class="pIconRightDown"></Icon></span>
            <span v-if="countInfo.todayAnswer<0"><Icon type="arrow-down-a" class="pIconRightDown"></Icon></span>
            <span v-if="countInfo.todayAnswer===0"><Icon type="android-remove" class="pIconRightDown"></Icon></span>
          </p>
          </Col>
          <Col span="6">
          <p>
            <Icon type="person" class="pIcon"></Icon>
            新增盲人
          </p>
          <p class="showData" style="font-size: 36px;margin-top:20px">{{defaultKey}}
            <span v-if="defaultKey>0"><Icon type="arrow-up-a" class="pIconRightDown"></Icon></span>
            <span v-if="defaultKey<0"><Icon type="arrow-down-a" class="pIconRightDown"></Icon></span>
            <span v-if="defaultKey===0"><Icon type="android-remove" class="pIconRightDown"></Icon></span>
          </p>
          </Col>
          <Col span="6">
          <p>
            <Icon type="android-happy" class="pIcon"></Icon>
            新增志愿者
          </p>
          <p class="showData" style="font-size: 36px;margin-top:20px">{{countInfo.todayAddVolunteer}}
            <span v-if="countInfo.todayAddVolunteer>0"><Icon type="arrow-up-a" class="pIconRightDown"></Icon></span>
            <span v-if="countInfo.todayAddVolunteer<0"><Icon type="arrow-down-a" class="pIconRightDown"></Icon></span>
            <span v-if="countInfo.todayAddVolunteer===0"><Icon type="android-remove" class="pIconRightDown"></Icon></span>
          </p>
          </Col>
        </Row>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
// import imgSrc from "@/assets/images/avatar.jpg";
// import utils from "@/utils";
// import adminMap from "./admin-map";
// import visiteVolume from "./visite-volume";
// import dataSourcePie from "./data-source";
// import userFlow from "./user-flow";
// import List from "../../../../firstVue/src/components/List";
// import axios from 'axios';

export default {
  name:"AdminHome",
  data(){
    return{
      countInfo:{},
      list:true,
      defaultKey:0//后台数据缺失，默认为0
    };
  },
  created() {
    this.$http.get('/zm/backManage/queryIndexInfo').then(res => {
      // console.log(res.data);
      this.countInfo=res.data.content;
    });
  },
  methods:{
  }
};
</script>

<style lang="less" scoped>
  .home-container{
    width: 100%;
    height: 400px;
    border: solid 1px #cad5d9;
  }

  .home-container p{
    font-size: 14px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 31px;
    margin-top: 5px;
    color: rgba(80, 80, 80, 1);
    white-space: normal;
  }

  .pIcon{
    font-size: 24px;
    margin-right: 8px;
    color:rgba(166, 166, 166, 1);
  }

  .pIconRight{
    font-size: 24px;
    color:rgba(166, 166, 166, 1);
    margin-left: 20px;
    opacity: 0;
  }

  .pIconRightDown{
    font-size: 24px;
    color:rgba(166, 166, 166, 1);
    margin-left: 20px;
  }

  .showData{
    font-size: 36px;
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// admin-home.vue?4410cf9e